/* tslint:disable */
import { TranslateService } from '@ngx-translate/core';

export abstract class DynamicWidget {
  /**
   * @name translateToolTipWidgetIcon
   * @description Translates tooltip widget icon
   */
  public translateToolTipWidgetIcon(
    expandWidget: __esri.Expand,
    translate: TranslateService,
    tooltip: string
  ) {
    translate.get(tooltip).subscribe(translate => {
      expandWidget.collapseTooltip = translate;
      expandWidget.expandTooltip = translate;
    });
  }
}
